
import { type RouteRecord } from 'vite-react-ssg';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '../contexts/ThemeContext';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ProductPage from '../pages/product/page';
import DemoPage from '../pages/demo/page';
import ContactPage from '../pages/contact/page';
import BlogPage from '../pages/blog/page';
import CheckPage from '../pages/check/page';
import PrivacyPage from '../pages/privacy/page';
import CookiesPage from '../pages/cookies/page';
import TermsPage from '../pages/terms/page';

function RootLayout() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-black">
        <main>
          <Outlet />
        </main>
      </div>
    </ThemeProvider>
  );
}

const routes: RouteRecord[] = [
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'product', element: <ProductPage /> },
      { path: 'demo', element: <DemoPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'blog', element: <BlogPage /> },
      { path: 'check', element: <CheckPage /> },
      { path: 'privacy', element: <PrivacyPage /> },
      { path: 'cookies', element: <CookiesPage /> },
      { path: 'terms', element: <TermsPage /> },
      { path: '*', element: <HomePage /> },
    ],
  },
];

export default routes;
